<ion-header>
  <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="calls-wrap page-width-and-shadow">
    <app-call-details
      *ngIf="data"
      [data]="data"
      (doGoBack)="closeRecord()"
    ></app-call-details>
  </div>
</ion-content>
